export const LOGIN_PATH = '/auth/login';
export const LOGIN_REDIRECT_QUERY_KEY = 'redirect';

const isReturnable = (path: string): boolean => path !== '/' && !path.startsWith('/auth');

export function buildLoginUrl(path: string): string {
    if (!isReturnable(path)) return LOGIN_PATH;
    return `${LOGIN_PATH}?${LOGIN_REDIRECT_QUERY_KEY}=${encodeURIComponent(path)}`;
}

// Protocol-relative (`//host`) and backslash (`/\host`) values would leave the app: open redirect.
export function parseLoginRedirect(value: unknown): string | null {
    const raw = Array.isArray(value) ? value[0] : value;
    if (typeof raw !== 'string') return null;
    if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return null;
    return isReturnable(raw.split(/[?#]/)[0]) ? raw : null;
}
